/* ══════════════════════════════
   색상 팔레트
══════════════════════════════ */
export const C = {
  bg:     "#F8F8F6",
  bg2:    "#F0F0EE",
  ink:    "#1A1A1A",
  muted:  "#A8A8A4",
  border: "#C8C4BC",
  accent: "#86A9CD",
  hover:  "#4A7AB5",
  white:  "#FFFFFF",
};

/* ══════════════════════════════
   슬러그 헬퍼
══════════════════════════════ */
export const toSlug = (str) =>
  str.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");

/* ══════════════════════════════
   기본 제품 데이터
══════════════════════════════ */
export const DEFAULT_PRODUCTS = [
  {
    id: 1, slug: "technical-training-tee",
    name: "Technical Training Tee", cat: "Top", subcat: "T-Shirts", price: 58000, tag: "NEW",
    sizes: ["XS","S","M","L","XL"],
    desc: "400gsm 헤비웨이트 코튼. 오버사이즈 박스 핏으로 활동성과 스타일을 동시에. 효소 워싱 처리로 처음부터 부드러운 착용감.",
    fabric: "100% Cotton (400gsm)", origin: "Made in Portugal", fit: "Oversized Box Fit",
    naverUrl: "https://smartstore.naver.com/your-store", imgs: [null,null,null,null],
  },
  {
    id: 2, slug: "wind-resistant-jacket",
    name: "Wind Resistant Jacket", cat: "Outwear", subcat: "Jackets", price: 189000, tag: "BEST",
    sizes: ["S","M","L","XL"],
    desc: "320gsm 워싱 캔버스 소재. 착탈식 플리스 라이너로 사계절 활용 가능. YKK 지퍼 사용.",
    fabric: "320gsm Washed Canvas", origin: "Made in Japan", fit: "Boxy Coach Fit",
    naverUrl: "https://smartstore.naver.com/your-store", imgs: [null,null,null,null],
  },
  {
    id: 3, slug: "compression-running-pant",
    name: "Compression Running Pant", cat: "Bottom", subcat: "Pants", price: 79000, tag: null,
    sizes: ["XS","S","M","L","XL","XXL"],
    desc: "고탄성 컴프레션 원단으로 근육 피로 감소. 내부 주머니 포함. 반사 디테일로 야간 운동 시 안전.",
    fabric: "88% Polyester 12% Spandex", origin: "Made in Korea", fit: "Slim Compression",
    naverUrl: "https://smartstore.naver.com/your-store", imgs: [null,null,null,null],
  },
  {
    id: 4, slug: "athletic-zip-up-hoodie",
    name: "Athletic Zip-Up Hoodie", cat: "Top", subcat: "Hoodies", price: 139000, tag: "NEW",
    sizes: ["S","M","L","XL"],
    desc: "380gsm 브러쉬드 플리스. 내부 집업 포켓. 리브드 커프스 & 헴. 내추럴 스트레치 원단.",
    fabric: "380gsm Brushed Fleece", origin: "Made in Portugal", fit: "Relaxed Drop Shoulder",
    naverUrl: "https://smartstore.naver.com/your-store", imgs: [null,null,null,null],
  },
  {
    id: 5, slug: "utility-track-pant",
    name: "Utility Track Pant", cat: "Bottom", subcat: "Pants", price: 99000, tag: "BEST",
    sizes: ["XS","S","M","L","XL"],
    desc: "240gsm 립스톱 나일론. 6개 포켓. 발목 스트랩 조절 가능. 방수 코팅 처리.",
    fabric: "240gsm Ripstop Nylon", origin: "Made in Japan", fit: "Wide Leg Utility",
    naverUrl: "https://smartstore.naver.com/your-store", imgs: [null,null,null,null],
  },
  {
    id: 6, slug: "lightweight-shell-vest",
    name: "Lightweight Shell Vest", cat: "Outwear", subcat: "Vests", price: 119000, tag: null,
    sizes: ["S","M","L","XL"],
    desc: "초경량 쉘 소재. 패커블 디자인으로 휴대 간편. 가슴 포켓 내장.",
    fabric: "100% Nylon Shell", origin: "Made in Japan", fit: "Regular Fit",
    naverUrl: "https://smartstore.naver.com/your-store", imgs: [null,null,null,null],
  },
  {
    id: 7, slug: "performance-base-layer",
    name: "Performance Base Layer", cat: "Top", subcat: "Base Layers", price: 49000, tag: null,
    sizes: ["XS","S","M","L","XL","XXL"],
    desc: "흡습속건 기능성 원단. 플랫 심 처리로 피부 자극 최소화. UPF 50+ 자외선 차단.",
    fabric: "100% Recycled Polyester", origin: "Made in Korea", fit: "Slim Fit",
    naverUrl: "https://smartstore.naver.com/your-store", imgs: [null,null,null,null],
  },
  {
    id: 8, slug: "cross-training-short",
    name: "Cross-Training Short", cat: "Bottom", subcat: "Shorts", price: 69000, tag: "NEW",
    sizes: ["XS","S","M","L","XL"],
    desc: "스트레치 우븐 소재. 내부 라이너 포함. 측면 슬릿 디테일.",
    fabric: "94% Polyester 6% Elastane", origin: "Made in Korea", fit: "Regular Fit",
    naverUrl: "https://smartstore.naver.com/your-store", imgs: [null,null,null,null],
  },
];

export const SLIDES = [
  { id:1, img:"/images/hero1.jpg", label:"26 S/S — TRAINING",    sub:"움직임을 위해 설계된 옷" },
  { id:2, img:"/images/hero2.jpg", label:"26 S/S — PERFORMANCE", sub:"기능과 스타일의 균형" },
  { id:3, img:"/images/hero3.jpg", label:"26 S/S — ESSENTIALS",  sub:"매일 입는 스포츠 유니폼" },
];

export const CATS      = ["All","Top","Bottom","Outwear"];
export const ALL_SIZES = ["XS","S","M","L","XL","XXL"];

/* ══════════════════════════════
   어드민 자격증명 (Supabase Auth로 대체됨)
   — 이 값은 더 이상 사용되지 않습니다
══════════════════════════════ */
export const ADMIN_USER = "";
export const ADMIN_PASS = "";
